import { useState } from 'react';
import { withBase } from '../utils/apiBase';

export const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitMessage('');

        try {
            const response = await fetch(withBase('/contact'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                setMessageType('success');
                setSubmitMessage(data.message);
                setFormData({ name: '', email: '', message: '' });
            } else {
                setMessageType('error');
                setSubmitMessage(data.message);
            }
        } catch (error) {
            setMessageType('error');
            setSubmitMessage('Network error. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const fieldClasses =
        'w-full px-4 py-3 bg-offwhite border border-line rounded-btn text-ink placeholder-ink_soft/60 focus:outline-none focus:ring-2 focus:ring-gold focus:border-forest transition-colors';

    return (
        <div className="max-w-2xl mx-auto">
            <div className="oli-paper border border-line rounded-card shadow-card p-8 sm:p-10">
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="name" className="block text-sm font-bold text-forest mb-2">
                            Name *
                        </label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className={fieldClasses}
                            placeholder="Your full name"
                        />
                    </div>

                    <div>
                        <label htmlFor="email" className="block text-sm font-bold text-forest mb-2">
                            Email *
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className={fieldClasses}
                            placeholder="your.email@example.com"
                        />
                    </div>

                    <div>
                        <label htmlFor="message" className="block text-sm font-bold text-forest mb-2">
                            Message *
                        </label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                            rows={5}
                            className={`${fieldClasses} resize-none`}
                            placeholder="Tell us about your questions, ideas, or how you'd like to get involved..."
                        />
                    </div>

                    {submitMessage && (
                        <div
                            role="status"
                            className={`p-4 rounded-btn border text-sm font-semibold ${
                                messageType === 'success'
                                    ? 'bg-forest/5 text-forest border-forest/30'
                                    : 'bg-flag_red/5 text-flag_red_deep border-flag_red/30'
                            }`}
                        >
                            {submitMessage}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full bg-forest hover:bg-forest_soft text-cream py-4 px-6 rounded-btn font-bold uppercase tracking-label text-sm focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isSubmitting ? 'Sending...' : 'Send Your Message'}
                    </button>
                </form>

                <div className="mt-8 pt-6 border-t border-line text-center">
                    <p className="text-ink_soft text-base">
                        Or email us directly at{' '}
                        <a
                            href="mailto:info@oligardens.org"
                            className="text-forest font-bold underline decoration-gold/60 underline-offset-2 hover:text-gold transition-colors duration-200"
                        >
                            info@oligardens.org
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};
